export default "__VITE_ASSET__BpKEgeYe__"